import * as React from 'react';

import { PropertyLevelOffersMessage } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const PropertyLevelOffersMessageWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <PropertyLevelOffersMessage inputs={inputs} skipSsr={true} />
);

PropertyLevelOffersMessageWrapper.displayName = 'PropertyLevelOffersMessageWrapper';
export const SharedUiPropertyLevelOffersMessageWrapper = withSharedUiPropertyOffers(PropertyLevelOffersMessageWrapper);
